import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';
import { menuAim } from './menu-aim';
import { TimelineLite } from 'gsap';
import focusWithin from 'ally.js/esm/style/focus-within.js';

Snappy.Component.CFANav = class CFANav extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-nav';
    }

    constructor(element) {
        super(element);
    }

    render() {
        
        this.setVars();
        this.setEventListeners();

        if (App.isDesktop) {
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            this.initKeyboardNavigation();
            this.switchTabOrder();
        } else {
            this.initMobile();
        }
        
        

        let handle = focusWithin();
    }

    setVars() {
        this.stickyElement = this.$element.find('.js-sticky-nav');
        this.stickyContainer = this.$element.find('.js-sticky-nav-container');

        this.navContainer = this.$element.find('.js-cfa-nav-container');
        this.mobileNavOpener = this.$element.find('.js-mobile-nav-opener');

        this.mainNav = this.$element.find('.js-cfa-main-nav');
        this.subNav = this.$element.find('.js-cfa-sub-nav');

        this.secondLevelMenu = this.$element.find('.js-cfa-second-level-menu');
        this.secondLevelMenuItem = this.$element.find('.js-cfa-nav-second-level-item');
        this.menuContent = this.$element.find('.js-cfa-menu-content');

        this.navSecondLevelMenu = this.$element.find('.js-cfa-nav-second-level-menu');

        this.thirdLevelMenu = this.$element.find('.js-cfa-nav-third-level-menu');
        this.menuItem = this.$element.find('.js-menu-item');

        this.navFeatured = this.$element.find('.cfa-menu__featured');
        this.menuItemForward = this.$element.find('.cfa-nav__item .cfa-nav__header .js-menu-item-forward').parent();

        this.menuItemForwardThirdLevel = this.$element.find('.cfa-menu__item .js-menu-item-forward').parent();
        this.menuItemBackward = this.$element.find('.js-menu-item-backward');

        this.firstLevelButtons = this.$element.find('.js-cfa-nav-first-level-button');
        this.secondLevelButtons = this.$element.find('.js-cfa-nav-second-level-button');
        this.activeFirstLevelItem = null;
        this.activeSecondLevelItem = null; 

        this.isSearchOpened = false;
        this.search = this.$element.find('.js-cfa-search');
        this.openSearch = this.$element.find('.js-cfa-search-open');
        this.closeSearch = this.$element.find('.js-cfa-search-close');
        this.searchForm = this.$element.find('.js-cfa-search-form');
        this.searchInput = this.$element.find('.js-cfa-search-input');
        this.searchUrl = this.search.data('url');
        this.isGoogleSearch = this.search.is('[data-google-search]');

        this.isMobile = !App.isDesktop;
        this.isRunning = false;
        this.isDesktopMenuOpened = false;
        this.isMobileMenuOpened = false;
        this.isMenuFocused = false;
        this.isSticky = false;
        this.translateValue = 0;
        this.scrollAmt = window.pageYOffset || document.documentElement.scrollTop;
    }

    setEventListeners() {
        this.$window.on('resize:finished', (this.bindedResize = this.onResize.bind(this)));
        if(!this.$body.hasClass('cw-new-theme')) {
            this.$body.on('body:block', this.onBodyBlock.bind(this));
            this.$body.on('body:unblock', this.onBodyUnblock.bind(this));
        }

        this.navContainer.on('transitionend', this.onNavTransitionEnd.bind(this));
        this.openSearch.on('click', this.onSearchOpen.bind(this));
        this.searchInput.on('keyup', this.onSearchKeyup.bind(this));

        $(document).on('show.bs.modal', '#IrSignInModal', this.onModalShow.bind(this));
        $(document).on('hidden.bs.modal', '#IrSignInModal', this.onModalHide.bind(this));

        $(document).ready(() => {
            $(this.menuItem).map((i, elem) => {
                if ($(elem).find('.js-cfa-nav-third-level-menu').length > 0) {
                    $(elem).addClass('has-third-level')
                }
                if ($(elem).find('.js-cfa-nav-second-level-menu').length > 0) {
                    $(elem).addClass('has-sec-level')
                }
            })

           // this.$element.find('a').attr('tabindex', '0');
                
        })
    }

    initKeyboardNavigation() {
        this.firstLevelButtons.on('click keypress', this.onClickFirstLevelButton.bind(this));
        this.secondLevelButtons.on('click keypress', this.onClickSecondLevelButton.bind(this));

        this.secondLevelButtons.keypress(function (e) {
            console.log("test")
            if (e.which === 32) {
                console.log("test")
                //Your code goes here

            }
        });
        //this.firstLevelButtons.on('KeyboardEvent.altKey ', this.onClickFirstLevelButton.bind(this));
        //this.secondLevelButtons.on('KeyboardEvent.altKey ', this.onClickSecondLevelButton.bind(this));
    }

    onModalShow() {
        if (this.clientHeight <= window.innerHeight) {
            return;
        }
        const scrollbarWidth = this.getScrollBarWidth();
        if (scrollbarWidth) {
            this.stickyElement
                .filter((index, el) => {
                    return $(el)
                        .parents('.js-sticky-nav-container')
                        .hasClass('is-fixed');
                })
                .css('padding-right', scrollbarWidth);
        }
    }

    onModalHide() {
        this.stickyElement
            .filter((index, el) => {
                return $(el)
                    .parents('.js-sticky-nav-container')
                    .hasClass('is-fixed');
            })
            .css('padding-right', 0);
    }

    getScrollBarWidth() {
        var inner = document.createElement('p');
        inner.style.width = '100%';
        inner.style.height = '200px';

        var outer = document.createElement('div');
        outer.style.position = 'absolute';
        outer.style.top = '0px';
        outer.style.left = '0px';
        outer.style.visibility = 'hidden';
        outer.style.width = '200px';
        outer.style.height = '150px';
        outer.style.overflow = 'hidden';
        outer.appendChild(inner);

        document.body.appendChild(outer);
        var w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var w2 = inner.offsetWidth;
        if (w1 == w2) w2 = outer.clientWidth;

        document.body.removeChild(outer);

        return w1 - w2;
    }

    onClickFirstLevelButton(event) {
        if(event.which == 13 || event.type == "click"){
            const activeFirstLevelItem = $(event.target).parents('.js-cfa-nav-first-level-item');

            event.preventDefault();
            event.stopPropagation();

            if (this.activeFirstLevelItem) {
                if (this.activeSecondLevelItem) {
                    this.deactivateThirdLevelMenu(this.activeSecondLevelItem);
                    this.closeThirdLevelMenu(this.activeSecondLevelItem);
                    this.activeSecondLevelItem = null;
                }

                this.deactivateSecondLevelMenu();
                this.closeSecondLevelMenu();

                if (activeFirstLevelItem[0] === this.activeFirstLevelItem[0]) {
                    this.activeFirstLevelItem = null;
                    return;
                }
            }

            this.activeFirstLevelItem = activeFirstLevelItem;
            this.activateSecondLevelMenu(event.target);
        }
    }

    onClickSecondLevelButton(event) {
        if(event.which == 13 || event.type == "click"){
            const activeSecondLevelItem = $(event.target).parents('.js-cfa-nav-second-level-item');

            event.preventDefault();
            event.stopPropagation();

            if (this.activeSecondLevelItem) {
                this.deactivateThirdLevelMenu();
                this.closeThirdLevelMenu();

                if (activeSecondLevelItem[0] === this.activeSecondLevelItem[0]) {
                    this.activeSecondLevelItem = null;
                    return;
                }
            }

            this.activeSecondLevelItem = activeSecondLevelItem;
            this.activateThirdLevelMenu(event.target);
        }
    }

    initSearch() {
        this.search.on('transitionend', this.onSearchTransitionEnd.bind(this));
        this.closeSearch.on('click', this.onSearchClose.bind(this));
    }

    onSearchKeyup(e) {
        if (e && e.keyCode === 13) {
            this.onSearchSubmit();
        }
    }

    onSearchSubmit() {
        const keyword = this.searchInput.val();

        if (keyword === '') {
            return;
        }

        if (this.isGoogleSearch) {
            const query = this.searchForm.serialize();
            window.location.href = this.searchForm.attr('action') + '?' + query;
        } else {
            window.location.href = this.searchUrl + '?keyword=' + keyword + '&page=1';
        }

        const currentSection = this.searchForm.data('currentSection');
        if (currentSection && !this.isSubmitTracked) {
            $(window).trigger('gtm:send', [currentSection, 'Search', keyword]);
            this.isSubmitTracked = true;
        }
    }

    onSearchOpen(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        const inputValue = this.searchInput.val();

        if (this.isMobile) {
            if (inputValue !== '') {
                this.onSearchSubmit();
            }

            return;
        }

        if (this.isSearchOpened && inputValue !== '') {
            this.onSearchSubmit();
        } else {
            this.isSearchOpened = true;
            this.search.addClass('cfa-search--opened');
            this.search.addClass('cfa-search--visible');
        }
    }

    onSearchClose(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        this.isSearchOpened = false;
        this.search.removeClass('cfa-search--opened');
        this.openSearch.focus();
    }

    onSearchTransitionEnd(e) {
        if (e.target !== this.search[0]) {
            return;
        }

        if (this.isSearchOpened) {
            this.searchInput.focus();
        } else {
            this.search.removeClass('cfa-search--visible');
        }
    }

    initMenuAim() {
        this.mainNav.menuAim({
            rowSelector: '> ul > li',
            submenuDirection: 'below',
            tolerance: 0,
            activate: function(el) {
                this.activateSecondLevelMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateSecondLevelMenu(el);
            }.bind(this),
            exitMenu: this.closeSecondLevelMenu.bind(this)
        });

        this.subNav.menuAim({
            activate: function(el) {
                this.activateThirdLevelMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateThirdLevelMenu(el);
            }.bind(this),
            exitMenu: this.closeThirdLevelMenu.bind(this)
        });
    }

    activateSecondLevelMenu(triggerElem) {
        if (this.isSearchOpened) {
            return;
        }

        this.activeFirstLevelItem = $(triggerElem).hasClass('js-cfa-nav-first-level-item')
            ? $(triggerElem)
            : $(triggerElem).parents('.js-cfa-nav-first-level-item');
        this.activeFirstLevelItem.addClass('cfa-nav__item--active');

        const newMenu = this.activeFirstLevelItem.find('.js-cfa-nav-second-level-menu').get(0);

        if (newMenu && !this.isDesktopMenuOpened) {
            let newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween.set(newMenu, { display: 'block' });
            this.tween.set(newContent, { autoAlpha: 1 });
            this.tween.to(newMenu, 0.2, {
                autoAlpha: 1,
                ease: Power0.easeNone
            });
            this.tween.play();

            //newMenu.style.pointerEvents = 'auto';

            this.isDesktopMenuOpened = true;
            this.currentDesktopMenu = newMenu;
        } else if (newMenu && this.isDesktopMenuOpened) {
            let oldMenu = this.currentDesktopMenu,
                oldContent = oldMenu.querySelector('.js-cfa-menu-content'),
                newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(oldContent, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(newMenu, { display: 'block', autoAlpha: 1 })
                .set(oldMenu, { display: 'none', autoAlpha: 0 })
                .to(newContent, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            //oldMenu.style.pointerEvents = 'none';
            //newMenu.style.pointerEvents = 'auto';

            this.currentDesktopMenu = newMenu;
        } else {
            this.closeSecondLevelMenu();
        }
    }

    closeSecondLevelMenu() {
        if (this.isDesktopMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                })
                .set(this.currentDesktopMenu, { display: 'none' })
                .set(this.currentDesktopMenu.querySelector('.js-cfa-menu-content'), {
                    autoAlpha: 1
                });
            this.tween.play();

            this.currentDesktopMenu.style.pointerEvents = 'none';

            this.currentDesktopMenu = null;
            this.isDesktopMenuOpened = false;
        }

        return true;
    }

    deactivateSecondLevelMenu() {
        if (this.isSearchOpened) {
            return;
        }

        this.activeFirstLevelItem.removeClass('cfa-nav__item--active');
    }

    activateThirdLevelMenu(triggerElem) {
        this.activeSecondLevelItem = $(triggerElem).hasClass('js-cfa-nav-second-level-item')
            ? $(triggerElem)
            : $(triggerElem).parents('.js-cfa-nav-second-level-item');
        this.activeSecondLevelItem.addClass('cfa-menu__item--active');

        const newSubMenu = this.activeSecondLevelItem.find('.js-cfa-nav-third-level-menu')[0];

        if (newSubMenu && !this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, {
                    height:
                        newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight
                            ? newSubMenu.scrollHeight + 40
                            : 'auto'
                })
                .to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            //newSubMenu.style.pointerEvents = 'auto';

            this.isDesktopSubMenuOpened = true;
            this.currentDesktopSubMenu = newSubMenu;
        } else if (newSubMenu && this.isDesktopSubMenuOpened) {
            let oldSubMenu = this.currentDesktopSubMenu;
            
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, {
                    height:
                        newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight
                            ? newSubMenu.scrollHeight + 40
                            : 'auto'
                })
                .to(oldSubMenu, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(oldSubMenu, { display: 'none' })
                .to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();
            

            this.currentDesktopSubMenu = newSubMenu;
        } else {
            this.closeThirdLevelMenu();
            
        }
    }

    deactivateThirdLevelMenu(el) {
        if (!this.activeSecondLevelItem) return;

        this.activeSecondLevelItem.removeClass('cfa-menu__item--active');
        //this.activeSecondLevelItem.find('.cfa-menu__submenu').style.pointerEvents = 'none';

        
    }

    closeThirdLevelMenu() {
        if (this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopSubMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                })
                .set(this.currentDesktopSubMenu, { display: 'none' })
                .set(this.currentDesktopMenu, { height: 'auto' });
            this.tween.play();

            //this.currentDesktopSubMenu.style.pointerEvents = 'none';

            this.currentDesktopSubMenu = null;
            this.isDesktopSubMenuOpened = false;
        }

        return true;
    }

    tweenPromote(tween) {
        if (typeof tween === 'undefined' || tween == null) return;

        if (typeof tween.progress === 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy === 'function') {
            tween.destroy();
        }
    }

    destroyMenuAim() {
        this.mainNav.menuAim('destroy');
        this.subNav.menuAim('destroy');
        this.secondLevelMenu.removeAttr('style');
        this.menuContent.removeAttr('style');
        this.thirdLevelMenu.removeAttr('style');
    }

    initSticky() {
        if (this.$body.hasClass('is-experience-editor') || !this.stickyContainer.length) {
            return;
        }

        this.getStickyData();
        this.onScroll();
        $(window).on('scroll', (this.bindedScroll = this.onScroll.bind(this)));
    }

    destroySticky() {
        this.deactivateSticky();
        $(window).off('scroll', this.bindedScroll);
    }

    getStickyData() {
        this.stickyOffset = this.stickyContainer.height();
        this.offset = this.stickyElement.offset().top;
    }

    activateSticky() {
        this.stickyContainer.addClass('is-fixed');
        this.stickyContainer.css('height', this.stickyOffset);
    }

    deactivateSticky() {
        this.stickyContainer.removeClass('is-fixed');
        this.stickyContainer.css('height', 'auto');
        this.stickyContainer.removeClass('nav-hide');
        this.isSticky = false;
    }

    initMobile() {

        this.mobileNavOpener.on(
            'click',
            (this.bindedHamburgerClick = this.onHamburgerClick.bind(this))
        );
        this.menuItemForward.on(
            'click',
            (this.bindedForwardClick = this.onForwardClick.bind(this))
        );

        this.menuItemForwardThirdLevel.on(
            'click',
            (this.bindedForwardClickThirdLevel = this.onForwardClickThirdLevel.bind(this))
        );
        this.menuItemBackward.on(
            'click',
            (this.bindedBackwardClick = this.onBackwardClick.bind(this))
        );
        this.$element.find('.cfa-menu__list').on('click', (e) => {
            e.stopPropagation();
            console.log($(e.target).attr('class'))
            if (!$(e.target).hasClass('is-active') && $(e.target).hasClass('cfa-menu__list')) {
                this.thirdLevelMenu.removeClass('is-active');
                this.secondLevelMenuItem.removeClass('is-active');
                this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
                this.secondLevelMenuItem.removeClass('is-clicked');
                this.secondLevelMenuItem.find('a').off('click.activateLink');

            }
        })

        $(document).ready(() => {
            if (this.isMobile) {
                //this.$element.find('.cfa-menu__item.has-third-level .cfa-nav__link').removeAttr("href")

                this.$element.find('.cfa-nav__item.has-sec-level .cfa-nav__link').removeAttr("href");


                this.secondLevelButtons.empty();
                this.secondLevelButtons.html('<div class="cfa-menu__button-icon"></div>');
                if (this.navFeatured.children().length == 0){
                    this.navFeatured.empty();
                }

            }

            
        })
    }

    onBodyBlock() {
        this.pageOffset = this.$body.scrollTop();
        this.$body.addClass('is-blocked');
        this.$body.css('top', -this.pageOffset);
    }

    onBodyUnblock() {
        this.$body.css('top', 'initial');
        this.$body.removeClass('is-blocked');
        window.scrollTo(0, this.pageOffset);
    }

    destroyMobile() {
        this.resetMenu();
        this.mobileNavOpener.off('click', this.bindedHamburgerClick);
        this.menuItemForward.off('click', this.bindedForwardClick);
        this.menuItemForwardThirdLevel.off('click', this.bindedForwardClickThirdLevel);
        this.menuItemBackward.off('click', this.bindedBackwardClick);
        this.secondLevelMenuItem.find('a').off('click.activateLink');
    }

    resetMenu() {
        this.translateValue = 0;
        this.navContainer.css('transform', '');
        this.menuItem.removeClass('is-active');
        this.navFeatured.removeClass('is-hidden');
    }

    onHamburgerClick() {
        this.isMobileMenuOpened = !this.isMobileMenuOpened;
        setTimeout(() => {
            this.navFeatured.toggleClass("is-shown")
        }, 100);
       
        this.resetMenu();
        this.toggleHamburger();
        this.toggleMenu();
        this.toggleBodyBlock();

    }

    onNavTransitionEnd(e) {
        if (e.target !== this.navContainer[0]) {
            return;
        }

        this.isRunning = false;
        if (this.translateValue === -100) {
            this.subNav.find('li.is-active').removeClass('is-active');
        } else if (this.translateValue === 0) {
            this.mainNav.find('li.is-active').removeClass('is-active');
        }
    }

    onForwardClick(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        e.stopPropagation();

        const forwardLink = $(e.currentTarget);
        console.log(forwardLink.parent().attr('class'))
        if (!forwardLink.closest('.js-menu-item').hasClass('is-active')) {
            if (forwardLink.parent().hasClass('js-cfa-nav-first-level-item')) {
                this.mainNav.find('li.is-active').removeClass('is-active');
            }
            this.navFeatured.addClass('is-hidden');
            this.secondLevelMenuItem.removeClass('is-clicked');
            this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
            forwardLink.closest('.js-menu-item').addClass('is-active');
            this.secondLevelMenuItem.find('a').off('click.activateLink');

            //this.translateValue -= 100;
            //this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
        }
    }

    onForwardClickThirdLevel(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        e.stopPropagation();
        const forwardLink = $(e.currentTarget);

        if (forwardLink.closest('.js-menu-item').hasClass('is-active')) {
            this.secondLevelMenuItem.removeClass('is-active');
            this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
            this.secondLevelMenuItem.removeClass('is-clicked');
            //this.secondLevelMenuItem.find('a').off('click.activateLink');
        } else {
            //forwardLink.find('a').on('click.activateLink', () => {
            //    window.location.href = forwardLink.find('a').attr('href');
            //})
            if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
                this.thirdLevelMenu.removeClass('is-active');
                this.secondLevelMenuItem.removeClass('is-clicked');
            }

            if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
                this.thirdLevelMenu.removeClass('is-active');
                this.secondLevelMenuItem.removeClass('is-clicked');
            }

            this.secondLevelMenuItem.removeClass('is-active');
            this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
            forwardLink.closest('.js-menu-item').addClass('is-active');
            forwardLink.find('.cfa-menu__button-icon').addClass('cfa-menu__button-icon__minus');
            this.secondLevelMenuItem.addClass('is-clicked');
        }


        //if (forwardLink.find('.cfa-menu__button-icon').hasClass('cfa-menu__button-icon__minus')) {
        //    this.secondLevelMenuItem.removeClass('is-active');
        //    this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
        //    this.secondLevelMenuItem.removeClass('is-clicked');
        //    this.secondLevelMenuItem.find('a').off('click.activateLink');
        //} else {
        //    forwardLink.find('a').on('click.activateLink', () => {
        //        window.location.href = forwardLink.find('a').attr('href');
        //    })
        //    if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
        //        this.thirdLevelMenu.removeClass('is-active');
        //        this.secondLevelMenuItem.removeClass('is-clicked');
        //    }
        //    if (!forwardLink.closest('.js-menu-item').hasClass('is-active')) {
        //        this.secondLevelMenuItem.removeClass('is-active');
        //        this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
        //        forwardLink.closest('.js-menu-item').addClass('is-active');
        //        forwardLink.find('.cfa-menu__button-icon').addClass('cfa-menu__button-icon__minus');
        //        this.secondLevelMenuItem.addClass('is-clicked');
        //    }
            
        //}
        

        
    }

    onBackwardClick(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        if (this.isRunning) {
            return;
        } else {
            this.isRunning = true;
        }

        //const backwardLink = $(e.currentTarget);

        this.translateValue += 100;
        //this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
    }

    toggleHamburger() {
        this.mobileNavOpener.toggleClass('is-active', this.isMobileMenuOpened);
    }

    toggleMenu() {
        this.$element.toggleClass('is-mobile-active', this.isMobileMenuOpened);
    }

    toggleBodyBlock() {
        if (this.isMobileMenuOpened) {
            this.$body.trigger('body:block');
        } else {
            this.$body.trigger('body:unblock');
        }
    }

    onScroll() {
        if (this.isSticky !== this.offset < window.pageYOffset) {
            this.isSticky = !this.isSticky;

            if (this.isSticky) {
                this.activateSticky();
            } else {
                this.deactivateSticky();
            }
        }
        this.headerSticky();
    }

    headerSticky() {
        // Make an enquiry sticky ribbon hide from 50% of the screen on membership pages only
        var wind_url = window.location.href;
        if($(window).width() >= 1024) {
            if(parseInt(document.documentElement.scrollTop) >=  parseInt(document.documentElement.scrollHeight/1.4)) {
                this.stickyContainer.addClass('nav-hide');
                
              } 
              else {
                this.stickyContainer.removeClass('nav-hide');
             
                $(".cfa-header__main.js-sticky-nav-container .cfa-header__sticky.js-sticky-nav").show();
              }

             
            }
            
            else {
                this.stickyContainer.removeClass('nav-hide');
                $(".cfa-header__main.js-sticky-nav-container .cfa-header__sticky.js-sticky-nav").show();
            }
    }

    onResize() {
        let screenSize;

        if (App.isDesktop) {
            screenSize = 'desktop';
        } else {
            screenSize = 'mobile';
        }

        this.onBreakpointChange(screenSize);
    }

    onBreakpointChange(screenSize) {
        const wasMobile = this.isMobile;
        const isMobile = screenSize === 'mobile';

        if (isMobile && !wasMobile) {
            if (this.isSearchOpened) {
                this.onSearchClose();
            }

            this.destroySticky();
            //this.destroyKeyboardNavigation();
            this.destroyMenuAim();
            this.initMobile();
        } else if (!isMobile && wasMobile) {
            if (this.isMobileMenuOpened) {
                this.isMobileMenuOpened = false;
                this.toggleMenu();
                this.toggleHamburger();
                this.toggleBodyBlock();
            }

            this.destroyMobile();
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            //this.initKeyboardNavigation();
        }

        this.isMobile = isMobile;
        this.switchTabOrder();
    }

    switchTabOrder() {
        if (this.isMobile) {
            this.mainNav.insertAfter(this.search);
        } else {
            this.search.insertAfter(this.mainNav);
        }
    }
};

$(function () {
    var wind_url1 = window.location.href;
    if($(window).width() < 1025) {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 40) {
                 
                $(".cw-new-theme .cfa-nav-mobile").css("margin-top","0px"); 
                // $(".enquiry-ribbon").css({"top":"auto","bottom":"0","z-index":"2"});
                $(".cw-new-theme .cfa-header__content").css("margin-top","0px");
                $(".cw-new-theme .cfa-menu").css("padding-top","75px"); 
                $(".cw-new-theme .cfa-menu").css("margin-top","0px");          
            } 
            
            else {
                // $(".enquiry-ribbon").css({"top":"0","bottom":"auto","z-index":"2"});
                $(".cw-new-theme .cfa-nav-mobile").css("margin-top","40px");  
                $(".cw-new-theme .cfa-header__content").css("margin-top","38px"); 
                $(".cw-new-theme .cfa-menu").css("margin-top","40px"); 
                $(".cw-new-theme .cfa-menu").css("padding-top","73px");
                $(".enquiry-ribbon").show();
            }
          });
        }
        var CWCFANav = new Snappy.Component.CFANav();

    const accountUser = $('.accountArea__userName');
    const accountDropdown = $('.accountArea__dropdownItems');

    $(accountUser).click(function (event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $(accountDropdown).toggle();
    });

});



// WEBPACK FOOTER //
// ./components/cfa-nav/scripts/cfa-nav.js